module.exports = __webpack_public_path__ + "img/spiner.4dd07656.png";